module.exports = __webpack_public_path__ + "static/assets/7ff87acd3118d86a8397ef9763da4f70.png";